import Loading from "Components/Global/Loading";

import * as S from "./styles";

const SectionLoading = () => {
  return (
    <S.LoadingWrapper>
      <Loading />
    </S.LoadingWrapper>
  );
};

export default SectionLoading;
